//LIBRARY
import React from "react";
import { useNavigate } from "react-router-dom";

//RENDER
import ProgramHeader from "./Program.Header";
import ProgramSelectAddons from "./Program.SelectAddOn";
import TabSize from "../../../components/attributes/TabSize";
import { BottomBarScroll } from "../../../components/bar/Bottom.Bar";

//CONSTANTS

//CONTEXT
import { ContextCart } from "../../../context/Context.Cart";

//FUNCTION
import ProgramClickToCart from "../functions/Program.ClickSelectedToCart";
import FunctionLoadAddOn from "../functions/Program.FunctionLoadAddOn";
import {
  SYMBOL_CURRENCY,
  TEXT_ADD_TO_BASKET,
  TEXT_CONTACT_US,
} from "../../../utils/useConstants";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  STYLE_BG_PROGRAM_SELECT_ADDON,
  STYLE_BG_WHITE_PROGRAM_HEAD,
  STYLE_HEIGHT_BAR,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_PROGRAM,
  STYLE_PADDING_WINDOWS,
} from "../../../utils/useStyle";
import ProgramGoBackProgram from "./Program.GobackProgram";
import { ProgramHeadScroll } from "./Program.HeadScroll";
import { useIsMobile } from "../../../utils/useIsMobile";
import ProgramCalculateSelfPrice from "../Program.CalculateSelfPrice";
import { CreateThisReference } from "../../../utils/useObserver";
import { DrawerInfo } from "../../../components/drawerInfo/DrawerInfo.Main";
import { FunctionGetPathUrl } from "../../../utils/useFunction";

const TriggerObserver = React.forwardRef((props, ref) => {
  return <div ref={ref} />;
});

const ProgramDetail = ({
  backgroundImage,
  title,
  icon,
  type,
  program_des,
  master_id,
  baht,
  addons,
}) => {
  const navigate = useNavigate();

  const { setCart, Storage, cart } = React.useContext(ContextCart);

  const [value, setValue] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [addOn, setAddOn] = React.useState([]);
  const [water, setWater] = React.useState([]);
  const [extras, setExtras] = React.useState([]);
  const [tabMenu, setTabMenu] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [show, setShow] = React.useState(false);
  const [last, setLast] = React.useState(false);

  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();

  const refScreen = React.useRef(null);

  React.useEffect(() => {
    const findLastElement = document.getElementById("last-element");
    if (findLastElement) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio === 0) {
          setLast(false);
        } else {
          setLast(true);
        }
      });
      observer.observe(findLastElement);
      return () => observer.unobserve(findLastElement);
    }
  }, []);

  React.useEffect(() => {
    const pricingSize = sessionStorage.getItem("pricingSize");
    if (value) {
      return;
    } else if (pricingSize) {
      const thisTab = tabMenu.find((item) => {
        return item.size === pricingSize;
      });
      setValue(thisTab);
    } else {
      setValue(tabMenu[0]);
    }
  }, [tabMenu]);

  React.useEffect(() => {
    FunctionLoadAddOn(
      type,
      setAddOn,
      cart,
      setValue,
      setWater,
      setExtras,
      master_id,
      setTabMenu,
      setLoading,
      language,
      addons
    );
  }, [
    type,
    cart,
    setTabMenu,
    setWater,
    setAddOn,
    setExtras,
    setValue,
    language,
  ]);

  return (
    <div className={` mt-16 md:mt-[72px]  `}>
      {isMobile ? <ProgramHeadScroll title={title} icon={icon} /> : ""}
      <div className={``}>
        <div className="bg-white md:bg-laundry-bglight w-screen h-full z-20 pb-4 md:pb-11">
          <div
            className={` h-[155px] md:h-h_335 w-full  `}
            style={{
              backgroundImage: backgroundImage,
              backgroundSize: "cover",
              backgroundPosition: "top",
            }}
          >
            <ProgramGoBackProgram
              title={TEXT_CONTACT_US[language]}
              onCLickNavigate={() => {
                navigate("/ContactUs");
              }}
              textcolor=" cursor-pointer hover:underline"
              classname={`${
                language === "TH"
                  ? "  text-sm-th md:text-lg-th  "
                  : "  text-sm md:text-lg  "
              } h-16 md:h-h_124 md:pt-11 px-6  ${STYLE_MAX_WIDTH_DESKTOP} `}
            />
          </div>

          <div
            className={` -mt-[78px] md:-mt-211  ${STYLE_MAX_WIDTH_DESKTOP} `}
          >
            <div className={STYLE_PADDING_PROGRAM}>
              <div
                className={`${STYLE_BG_WHITE_PROGRAM_HEAD} ${
                  isMobile ? "ordershadow" : ""
                }`}
              >
                <ProgramHeader
                  descripion={program_des}
                  icon={icon}
                  title={title}
                  type={type}
                />
                <div className="  z-20 ">
                  <TabSize
                    value={value}
                    setValue={setValue}
                    tab={tabMenu}
                    open={open}
                    setOpen={setOpen}
                    type={type}
                  />
                </div>
              </div>
            </div>
            <div
              className={` ${STYLE_PADDING_WINDOWS} bg-white md:bg-transparent`}
            >
              <div ref={refScreen} className={STYLE_BG_PROGRAM_SELECT_ADDON}>
                <ProgramSelectAddons
                  type={type}
                  addOn={addOn}
                  setAddOn={setAddOn}
                  setExtras={setExtras}
                  setWater={setWater}
                  water={water}
                  extras={extras}
                  tab={value}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={` bg-white w-full ${STYLE_HEIGHT_BAR} `}>
          <BottomBarScroll
            refScreen={refScreen}
            bottompadding="false"
            onClick={(e) => {
              e.stopPropagation();
              ProgramClickToCart(
                setCart,
                addOn,
                Storage,
                value,
                navigate,
                water,
                extras,
                type
              );
            }}
            title={
              <div>
                {TEXT_ADD_TO_BASKET[language]} -{" "}
                <span className="font-normal mr-0.5">{SYMBOL_CURRENCY}</span>
                {ProgramCalculateSelfPrice(
                  [...addOn, ...extras],
                  value?.price,
                  master_id,
                  value?.size,
                  water
                )}
              </div>
            }
          />
        </div>
        {master_id && addOn && (
          <React.Fragment>
            <TriggerObserver ref={CreateThisReference(setShow)} />
            {!show && !last && (
              <div
                style={{
                  zIndex: 10,
                }}
                className={`  bg-white fixed bottom-0 w-full ${STYLE_HEIGHT_BAR} `}
              >
                <BottomBarScroll
                  refScreen={refScreen}
                  bottompadding="false"
                  onClick={(e) => {
                    e.stopPropagation();
                    ProgramClickToCart(
                      setCart,
                      addOn,
                      Storage,
                      value,
                      navigate,
                      water,
                      extras,
                      type
                    );
                  }}
                  title={
                    <div>
                      {TEXT_ADD_TO_BASKET[language]} -{" "}
                      <span className="font-normal mr-0.5">
                        {SYMBOL_CURRENCY}
                      </span>
                      {ProgramCalculateSelfPrice(
                        [...addOn, ...extras],
                        value?.price,
                        master_id,
                        value?.size,
                        water
                      )}
                    </div>
                  }
                />
              </div>
            )}
          </React.Fragment>
        )}
      </div>
      <DrawerInfo
        open={open}
        setOpen={setOpen}
        image={FunctionGetPathUrl(value?.image_key_desktop)}
        imageMobile={FunctionGetPathUrl(value?.image_key_mobile)}
        title={value?.ex}
        description={
          language === "TH"
            ? value?.addon_description_th
            : value?.addon_description_en
        }
        description2={
          language === "TH"
            ? value?.addon_description_2_th
            : value?.addon_description_2_en
        }
      />
    </div>
  );

  // }
};
export default ProgramDetail;
